import { render, staticRenderFns } from "./OrderCollectPurchases.vue?vue&type=template&id=71bb1774&"
import script from "./OrderCollectPurchases.vue?vue&type=script&lang=js&"
export * from "./OrderCollectPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports